<template>
    <div class="login_form">
        <div class="tabs">
            <span :class="{ active: loginType == 0 }" @click="loginType = 0">账号登录</span>
            <span :class="{ active: loginType == 1 }" @click="loginType = 1">短信登录</span>
        </div>
        <van-form @submitsubmit="onSubmit">
            <van-cell-group inset>
                <p class="label">手机号码</p>
                <van-field v-model="loginForm.mobile" name="mobile" placeholder="请输入账号（手机号码）"
                    :rules="[{ required: true, message: '请填写手机号码' }]" />
                <p class="label">密码</p>
                <van-field v-model="loginForm.password" type="password" name="password" placeholder="请输入密码"
                    :rules="[{ required: true, message: '请填写密码' }]" v-if="loginType == 0" />
                <van-row v-else>
                    <van-col span="16">
                        <van-field v-model="loginForm.code" name="code" placeholder="请填写验证码"
                            :rules="[{ required: true, message: '请填写验证码' }]" />
                    </van-col>
                    <van-col span="8">
                        <button class="code_btn" @click.stop="sendCode(loginForm.mobile)"
                            v-if="remainSecond <= 0">获取验证码</button>
                        <button class="code_btn" v-else>{{ remainSecond }}秒后获取</button>
                    </van-col>
                </van-row>
            </van-cell-group>
            <div style="margin-top: 20rem;">
                <van-button round block type="primary" native-type="submit" @click="login" style="background-color: #726FF9; border-radius: 5rem; height: 48rem;">
                    登录
                </van-button>
            </div>
        </van-form>
        <p class="register" >还没有帐号？ <span @click="emit('register')" style="color: #726FF9;">立即注册</span></p>
        <!-- <div class="line"></div> -->
        <div class="third_login">
            <span>第三方登录</span>
            <div class="icons">
                <van-icon :name="require('@/assets/imgs/icon51.png')" size="30rem" @click="loginThrid(10)"></van-icon>
                <van-icon :name="require('@/assets/imgs/icon52.png')" size="30rem" @click="loginThrid(50)"></van-icon>
            </div>
            <!-- <p style="font-size: 12rem;">还没有账号？<span style="color: #FF3D1D;" @click="isRegister = true;">去注册</span></p> -->
        </div>
    </div>
</template>
<script setup>
import { sendCode, remainSecond, clearTimer } from '@/utils/codeSender'
import cookie from 'cookie.js';
import { useRoute, useRouter } from 'vue-router';
import { showNotify } from 'vant';
import { AliPay, WeChat } from './Constants.js'
import { onMounted, reactive, ref, toRaw } from 'vue';
import { http } from '@/request/http'
const emit = defineEmits(['register'])
const loginType = ref(0)
const loginForm = reactive({
    // username: '',
    password: '',
    mobile: '',
    code: '',
    rememberMe: true
})

const route = useRoute()
const login = () => {
    http.post(loginType.value == 1 ? '/app-api/member/auth/sms-login' : '/app-api/member/auth/login', toRaw(loginForm)).then(res => {
        if (res && res.accessToken) {
            loginHandle(res)
        } else {
            showNotify({
                message: err || '登录失败',
                type: 'danger',
            })
        }
    }).catch(err => {
        showNotify({
            message: err || '登录失败',
            type: 'warning'
        })
    })
}

const loginThrid = type => {
    http.get('/app-api/member/auth/social-auth-redirect', {
        params: {
            type,  //微信10  支付宝50
            redirectUri: 'http://www.xinghancloud.com/workbench/login'
        }
    }).then(res => {
        if (res) {
            location.href = res
            clearTimer()
        }
    }).catch(err => {
        console.log(err);
        showNotify({
            message: err || '登录失败',
            type: 'danger',
        })
    })
}

const router = useRouter()
function loginHandle(res) {
    if (res.accessToken) {
        //已注册
        cookie.set('accessToken', res.accessToken, { path: '/' })
        cookie.set('tenantId', res.tenantId, { path: '/' })
        const path = route.query.path ? decodeURIComponent(route.query.path) : '/'
        // window.location.href = path
        router.replace(path)
    }
}

const onSubmit = (values) => {
    console.log('submit', values);
};


onMounted(() => {
    // if (cookie.get('accessToken')) {
    //     router.replace({ path: '/workbench' })
    // }

    const { source, auth_code, code, state } = route.query

    if (state) {
        const params = {
            state: state
        }
        //微信
        if (code) {
            params.code = code
            params.type = WeChat
        }
        //支付宝
        if (auth_code) {
            params.code = auth_code
            params.type = AliPay
        }
        http.post('/app-api/member/auth/social-login', params).then(res => {
            loginHandle(res)
        }).catch(err => {
            console.log(err);
            if (err == '用户不存在') {
                showNotify({
                    message: err || '登录失败',
                    type: 'danger',
                })
            }
        })
    }
})


</script>
<style scoped lang="scss">
.login_form {
    .tabs {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20rem;
        background-color: #eef1fe;
        padding: 5rem;
    }

    .tabs span {
        width: 50%;
        display: block;
        text-align: center;
        font-size: 18rem;
        padding: 10rem 10rem;
        cursor: pointer;
        border-radius: 5rem;
    }

    .tabs span.active {
        color: #726FF9;
        background-color: #fff;
        box-shadow: 0px 1px 10px  #716ff939;
    }

    .label{
        color: #666;
    }

    ::v-deep(.van-cell-group){
        background-color: transparent !important;
        margin: 0;
        .van-cell{
            background: transparent !important;
            padding: 10rem 0;
            .van-field__control{
                background-color: transparent !important;
                height: 42rem !important;
                line-height: 42rem;
                border: 1px solid #D8DAE6;
                padding: 0 10rem;
                // background-color: #fff;
            }
        }
    }

    .code_btn {
        margin: 10rem 0;
        height: 42rem;
        border: none;
        width: 100%;
        // background-color: #F8F8F8;
        background-color: transparent;
        border: 1px solid #D8DAE6;
        border-left: none;
        color: #999999;
    }
    .register {
        font-size: 14rem;
        margin-top: 10rem;
    }

    .line {
        width: 100%;
        height: 1px;
        background-color: #CCCCCC;
        margin: 10rem 0;
    }

    .third_login {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 20rem;

        .icons {
            margin: 10rem 0;

            .van-icon {
                margin: 0 10rem;
            }
        }
    }
}
</style>
